import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-info-icon',
  templateUrl: './lib-info-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibInfoIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
